import React, { useState } from 'react';
import { Button, Modal, Input, Form } from 'antd';
import styled from 'styled-components';
import { ArrowLeftOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import { validateUnits } from '../../../../utils/dashboards';

const StyledHeader = styled.div`
  margin: 0 45px 0 45px;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;

  .left-header {
    display: flex;
    flex-direction: row;
    height: 56px;
  }

  .arrow-left {
    border: 1px solid transparent;
    background-color: transparent;
  }

  .input {
    padding-left: 5px;
  }
`;

const StyledButton = styled(Button)`
  border: 1px solid transparent;
  background-color: transparent;
`;

const StyledInput = styled(Input)`
  padding-left: 5px;
`;

const { confirm } = Modal;

const checkNameLength = (name) => !(name.length > 0);

const checkUniqueName = (name, existedNames) => !existedNames.some((n) => n === name);

const validateCreatedDashboardName = (existedDashboardNames, name) => {
  let validationMessage = '';
  const isUniqueName = checkUniqueName(name, existedDashboardNames);
  const isEmptyName = checkNameLength(name);

  if (!isUniqueName) {
    validationMessage = 'Not unique name';
  }

  if (isEmptyName) {
    validationMessage = 'Empty name';
  }

  return [!isEmptyName && isUniqueName, validationMessage];
};

const validateEditedDashboardName = (existedDashboardNames, name, sourceDashboardName) => {
  let validationMessage = '';
  const isUniqueName = checkUniqueName(name, existedDashboardNames);
  const isEmptyName = checkNameLength(name);
  const isPrevNameEqualToCurrent = name === sourceDashboardName;

  if (!isUniqueName && !isPrevNameEqualToCurrent) {
    validationMessage = 'Not unique name';
  }

  if (isEmptyName) {
    validationMessage = 'Empty name';
  }

  const validationСondition = isPrevNameEqualToCurrent || isUniqueName;

  return [!isEmptyName && validationСondition, validationMessage];
};

const CreateHeaderDashboard = ({
  onBack,
  dashboardName,
  setDashboardName,
  saveDashboard,
  existedDashboardNames,
  isCreate,
  sourceDashboardName,
  units,
  setShowNotValidFields,
}) => {
  const [isValid, setValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const showConfirm = () => {
    confirm({
      title: 'Do you Want to leave the page without saving your changes?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        onBack();
      },
      onCancel() {},
    });
  };

  const onChange = (event) => {
    const name = event.target.value;

    if (!isValid) {
      setValid(true);
      setErrorMessage('');
    }

    setDashboardName(name);
  };

  const onClick = () => {
    const validateDashboardName = isCreate
      ? validateCreatedDashboardName
      : validateEditedDashboardName;

    const [isDashboardNameValid, message] = validateDashboardName(
      existedDashboardNames,
      dashboardName,
      sourceDashboardName
    );
    setErrorMessage(message);

    const isValidUnits = validateUnits(units);

    if (!isDashboardNameValid) {
      setValid(isDashboardNameValid);
    }

    if (!isValidUnits) {
      setShowNotValidFields(true);
    }

    if (isDashboardNameValid && isValidUnits) {
      saveDashboard();
      onBack();
    }
  };

  return (
    <StyledHeader>
      <div className="left-header">
        <StyledButton className="arrow-left" onClick={showConfirm}>
          <ArrowLeftOutlined />
        </StyledButton>
        <Form.Item validateStatus={!isValid && 'error'} help={errorMessage}>
          <StyledInput
            className="input"
            placeholder="Enter dashboard name"
            value={dashboardName}
            onChange={onChange}
          />
        </Form.Item>
      </div>
      <div>
        <Button type="primary" onClick={onClick}>
          Save
        </Button>
      </div>
    </StyledHeader>
  );
};

export default CreateHeaderDashboard;
